<template>
  <div>
    <div
      ref="editor"
      style="text-align: left; background-color: #ffffff"
    />
    <el-dialog
      :title="$t('sc.gallery.pickerImageDialogTitle')"
      :visible.sync="showGalleryPicker"
      width="960px"
      append-to-body
      :close-on-click-modal="false"
    >
      <GalleryPicker
        v-if="showGalleryPicker"
        mode="picker"
        default-file-type="image"
        :multiple="true"
        :max-select="galleryMaxDetailPick"
        @select="handleEditorGallerySelect"
        @close="showGalleryPicker = false"
      />
    </el-dialog>
  </div>
</template>

<script>
// import E from "wangeditor";
import i18next from 'i18next'
import { Compressor } from '@/plugins/CompressorImage.js'
import GalleryPicker from '_c/Gallery/GalleryPicker.vue'
import { GALLERY_MAX_DETAIL_PICK } from '_c/Gallery/constants'
export default {
  name: 'WangEditor',
  components: { GalleryPicker },
  data() {
    return {
      contentHtml: '',
      editor: null,
      isPaste: false,
      showGalleryPicker: false,
      galleryMaxDetailPick: GALLERY_MAX_DETAIL_PICK
    }
  },
  computed: {
    lang() {
      return this.$store.state.locale
    }
  },
  watch: {
    '$store.state.locale'() {
      this.destroyEditor()
      this.createEditor()
    }
  },
  mounted() {
    this.createEditor()
  },
  beforeUnmount() {
    this.destroyEditor()
  },
  methods: {
    setHtml(html) {
      // if (!process.browser) return
      this.contentHtml = html
      this.editor.txt.html(html)
    },
    getJson() {
      // if (!process.browser) return
      this.editor.txt.html(this.contentHtml)
      const jsonData = this.editor.txt.getJSON() // 获取文本的json格式
      return jsonData
    },
    // 转化成API要求的json格式
    getJsonData(json) {
      let content = ''
      const contentArr = []
      const _getJsonData = data => {
        // 为true是段落，否则是行。
        let p = true
        data.forEach(item => {
          if (typeof item === 'string') {
            content = item
            // 上一截字符串是段落，则本截字符串另起一段，否则追加在上一截字符串上
            if (p) {
              contentArr.push({
                type: 'text',
                content
              })
            } else {
              contentArr[contentArr.length - 1].content += content
            }
            p = false
          } else if (item.tag === 'br') {
            // 内容数组为空或者内容前是段落时
            if (!contentArr.length || p) {
              contentArr.push({
                type: 'text',
                content: '<br />'
              })
            } else {
              contentArr[contentArr.length - 1].content += '<br />'
            }
          } else if (item.tag === 'img') {
            const imgUrl = item.attrs[0].value
            // 2022/6/13调整为 所有图片保留整个url
            contentArr.push({ type: 'image', content: imgUrl })
            // contentArr.push({
            //   type: 'image',
            //   content:
            //     imgUrl.search(/perfee.+com/gi | /kili/gi) === -1
            //       ? imgUrl
            //       : imgUrl.match(/\d+\.(jpg|jpeg|png|gif)/gi)[0]
            // })
            p = true
          } else if (item.children && item.children.length) {
            return _getJsonData(item.children)
          }
        })
      }
      _getJsonData(json)
      return contentArr
    },
    getFormatDetail() {
      // if (!process.browser) return
      const jsonData = this.getJsonData(this.getJson())
      return jsonData
    },
    createEditor() {
      // if (!process.browser) return
      // nustjs问题，防止window is not defined
      const E = require('@/plugins/wangEditor.min.js')
      const editor = new E(this.$refs.editor)
      editor.config.onchange = newHtml => {
        let html = newHtml
        html = html.replace(/<\/?span.*?>/g, '')
        this.contentHtml = html
        if (this.isPaste) {
          // 对粘贴的内容进行格式化处理
          this.getFormatDetail()
          this.isPaste = false
        }
      }
      editor.config.onblur = newHtml => {
        this.$emit('blur:event', newHtml)
      }

      // 粘贴事件，在内容变化事件前面触发
      editor.txt.eventHooks.pasteEvents.push(() => {
        this.isPaste = true
      })

      // 自定义菜单配置
      editor.config.menus = [
        'image' // 插入图片
      ]

      editor.config.zIndex = 888
      // 限制一次最多上传 10 张图片
      editor.config.uploadImgMaxLength = 10
      // 配置上传图片的服务器端地址
      editor.config.uploadImgServer = `${this.$store.state.apiEnv}/upload-goods-images`
      // 监听函数在上传图片的不同阶段做相应处理
      editor.config.uploadImgHooks = {
        // customInsert: function (insertImg, result, editor) {
        //   console.log(result.data.files)
        //   //insertImg(result.data.imageUrl);
        //   result.data.files.forEach(item => {
        //     insertImg(item.fileUrl)
        //   })
        //   //insertImg(result.data.files.fileUrl);
        // },
        before: function(xhr, editor, files) {
          // console.log(this.resultfilire)
          const imgReg = /<img.*?(?:>|\/>)/gi
          // 匹配src属性
          const srcReg = /src=[\\"]?([^\\"]*)[\\"]?/i
          const arr = editor.txt.html().match(imgReg)
          const imgs = []
          if (arr) {
            for (let i = 0; i < arr.length; i++) {
              const src = arr[i].match(srcReg)[1]
              imgs.push(src)
            }
          }
          // if(files.length > 10-imgs.length){
          //   return {
          //     prevent: true,
          //     msg:`最多上传10张,您还能再上传${10-imgs.length}张`
          //   }
          // }
          if (imgs.length === 10) {
            return {
              prevent: true,
              msg: `最多上传10张,您还能再上传${10 - imgs.length}张`
            }
          } else if (imgs.length < 10) {
            if (files.length > 10 - imgs.length) {
              return {
                prevent: true,
                msg: `最多上传10张,您还能再上传${10 - imgs.length}张`
              }
            }
          }
        }
      }
      // 隐藏【网络图片】tab
      editor.config.showLinkImg = false
      // 定义图片名字
      // editor.config.uploadFileName = "file"
      // 粘贴样式的过滤
      editor.config.pasteFilterStyle = true
      // 忽略粘贴内容中的图片
      editor.config.pasteIgnoreImg = true
      // 设置编辑区域高度为 400px
      editor.config.height = 400
      const local = this.$store.state.locale
      // 选择语言
      editor.config.lang = local === 'zh' ? 'zh-CN' : local
      editor.i18next = i18next
      editor.config.customAlert = (s, t) => {
        const msgConf = { content: s, duration: 5 }
        switch (t) {
          case 'success':
            this.$Message.success(msgConf)
            break
          case 'info':
            this.$Message.info(msgConf)
            break
          case 'warning':
            this.$Message.warning(msgConf)
            break
          case 'error':
            this.$Message.error(msgConf)
            break
          default:
            this.$Message.info(msgConf)
            break
        }
      }

      editor.config.customUploadImg = (resultFiles, insertImgFn) => {
        this.showGalleryPicker = true
      }

      editor.create()
      this.editor = editor

      this.$nextTick(() => {
        const toolbar = this.$refs.editor.querySelector('.w-e-toolbar')
        if (toolbar && toolbar.children.length > 0) {
          const imageMenuEl = toolbar.children[0]
          imageMenuEl.addEventListener('click', (e) => {
            e.stopImmediatePropagation()
            e.preventDefault()
            this.showGalleryPicker = true
          }, true)
        }
      })
    },
    handleEditorGallerySelect(files) {
      if (this.editor && files.length > 0) {
        files.forEach((file) => {
          this.editor.cmd.do('insertHTML', `<img src="${file.fullUrl}" style="max-width:100%;">`)
        })
      }
      this.showGalleryPicker = false
    },
    destroyEditor() {
      // 调用销毁 API 对当前编辑器实例进行销毁
      this.editor.destroy()
      this.editor = null
    }
  }
}
</script>

<style scoped></style>
